<template>
  <div class="lang-selector">
      <p class="site-lang">{{text.siteLangs}}</p>
      <div class="langs">
          <div class="lang-item" v-for="lang in $langs" :key="lang.code" @click="() => {setLocale(lang.code)}">
              <img :src="lang.icon">
              <br>
              <p>{{lang.name}}</p>
          </div>
      </div>
  </div>
</template>

<script>
    export default {
        computed: {
            text(){
                return this.$texts[this.$i18n.locale].langSelector
            }
        },
        methods: {
            setLocale(locale){
                this.$i18n.locale = locale
                this.$sharedStore.set('locale', locale)
            }
        }
    }
</script>

<style lang="scss">
    .lang-selector {
        padding: vh(6) 3vw 0 3vw;
    }
    .site-lang {
        font-weight: bold;
        text-align: center;
    }

    .langs {
        display: flex;
        
        .lang-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex-grow: 1;
            height: vh(15);

            img {
                width: 20px;
                height: 20px;
                border-radius: 1000px;
                object-fit: cover;
                overflow: hidden;
            }
        }
    }
</style>